import { axiosInstance } from './apiUtils';
import { POLLING_INTERVAL, MAX_POLLING_ATTEMPTS } from './constants';

export interface CompraStatus {
  Id: number;
  Aprobada: boolean;
  CodigoEntrada: string;
  FechaCompra: string;
}

export const obtenerCompraPorId = async (idCompra: number): Promise<CompraStatus | null> => {
  try {
    const usuarioJSON = localStorage.getItem('usuario');
    const usuario = usuarioJSON ? JSON.parse(usuarioJSON) : null;

    if (!usuario || !usuario.Id) {
      return null;
    }

    const response = await axiosInstance.get<CompraStatus[]>(`/CompraEntrada/byUser/${usuario.Id}`);
    const compra = response.data.find(c => c.Id === idCompra);
    return compra || null;
  } catch {
    return null;
  }
};

export interface PollHandle {
  cancel: () => void;
  result: Promise<boolean>;
}

export const pollCompraStatus = (
  idCompra: number,
  onStatusChange: (aprobada: boolean) => void,
  maxAttempts: number = MAX_POLLING_ATTEMPTS,
  interval: number = POLLING_INTERVAL
): PollHandle => {
  let cancelled = false;

  const cancel = () => {
    cancelled = true;
  };

  const result = (async () => {
    let attempts = 0;

    while (attempts < maxAttempts && !cancelled) {
      try {
        const compra = await obtenerCompraPorId(idCompra);

        if (cancelled) return false;

        if (compra?.Aprobada) {
          onStatusChange(true);
          return true;
        }
      } catch {
        // continue polling
      }

      attempts++;

      if (attempts < maxAttempts && !cancelled) {
        await new Promise(resolve => setTimeout(resolve, interval));
      }
    }

    return false;
  })();

  return { cancel, result };
};
